import React, { memo, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArtistCardProps } from '../types';

const ArtistCard: React.FC<ArtistCardProps> = memo(({ artist, onArtistClick }) => {
  const navigate = useNavigate();

  const handleClick = useCallback(() => {
    if (onArtistClick) {
      onArtistClick(artist.slug);
    } else {
      // Fallback to router navigation if no onClick handler provided
      navigate(`/artist/${artist.slug}`);
    }
  }, [artist.slug, onArtistClick, navigate]);

  const handleKeyDown = useCallback((event: React.KeyboardEvent) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      handleClick();
    }
  }, [handleClick]);

  return (
    <div 
      className="artist-card" 
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      tabIndex={0}
      role="button"
      aria-label={`עبור לעמוד האמן ${artist.name}${artist.project_title ? ` - פרויקט ${artist.project_title}` : ''}`}
      style={{ cursor: 'pointer' }}
    >
      <div className="artist-image">
        <img 
          src={artist.image || artist.primary_artwork?.image_url} 
          alt={`יצירה של ${artist.name}${artist.project_title ? ` - ${artist.project_title}` : ''}`} 
          loading="lazy"
          onError={(e) => {
            // Fallback image if main image fails to load
            const target = e.target as HTMLImageElement;
            target.src = 'https://images.unsplash.com/photo-1578321272176-b7bbc0679853?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&h=300&q=80';
          }}
        />
      </div>
      <div className="artist-info">
        <h3 className="artist-name">
          {artist.name}
          {artist.project_title && (
            <span className="project-title"> | {artist.project_title}</span>
          )}
        </h3>
      </div>
    </div>
  );
});

ArtistCard.displayName = 'ArtistCard';

export default ArtistCard;